import fetch from "auth/FetchInterceptor";

const VendorPushService = {};

VendorPushService.registerToken = function (data) {
  return fetch({
    url: "/push-tokens/register/",
    method: "POST",
    data,
  });
};

VendorPushService.deactivateToken = function (data) {
  return fetch({
    url: "/push-tokens/deactivate/",
    method: "POST",
    data,
  });
};

export default VendorPushService;
